module.exports = __webpack_public_path__ + "static/media/3DPPA7.c0832238.jpg";